module.exports = __webpack_public_path__ + "assets/OrthicTriangle.f55a49d36ddc3d26ae468a4934e6d583.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/OrthicTriangle.gmt
// module id = 975
// module chunks = 0